<template>
  <v-card width="350" elevation="10">
    <v-card-text>
      <div class="text-center mb-5">
        <img src="../assets/logo.png" alt="Logo da D3V" />
      </div>
      <h2 class="font-weight-light my-5 text-center">Esqueci minha senha</h2>
      <v-text-field
        type="email"
        prepend-icon="mdi mdi-email"
        label="Digite seu e-mail"
        hint="Será enviado um link de redefinição de senha para seu e-email"
        persistent-hint
      />
      <v-btn depressed block color="accent" class="mt-4">
        <v-icon class="mdi mdi-send mr-2" />ENVIAR LINK DE REDEFINIÇÃO
      </v-btn>
      <v-btn text block :to="{ name: 'auth-login' }" class="mt-2"
        >VOLTAR PARA O LOGIN</v-btn
      >
    </v-card-text>
  </v-card>
</template>

<script>
export default {};
</script>
